var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAposInv({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "gen_apos") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M135.089,83.266c-38.061,6.99-67.574,34.952-67.574,66.8,0,3.884,3.1,3.884,4.657,1.551a60.258,60.258,0,0,1,23.309-5.435c17.863,0,34.952,15.534,34.952,40.39,0,24.078-20.972,43.5-44.273,43.5-31.849,0-52.048-25.63-52.048-64.468,0-63.695,55.15-97.869,96.322-100.979Zm122.725,0c-37.28,6.99-66.8,34.952-66.02,66.8,0,3.884,2.329,3.884,4.657,1.551,5.438-3.106,15.534-5.435,22.527-5.435,17.863,0,34.952,15.534,34.952,40.39s-20.972,43.5-43.492,43.5c-31.849,0-52.822-25.63-52.822-64.468,0-63.695,55.924-97.869,97.1-100.979Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAposInv);
export default __webpack_public_path__ + "static/media/aposInv.56d4020de7ba3522a16d636b7b98e612.svg";
export { ForwardRef as ReactComponent };